/**
 * @generated SignedSource<<e8166683eee73a2e23bf91cd5b96d9e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveMealLoggingEntryInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type RemoveMealLoggingEntryMutation$variables = {
  input: RemoveMealLoggingEntryInput;
};
export type RemoveMealLoggingEntryMutation$data = {
  readonly removeMealLoggingEntry: {
    readonly removeMealLoggingEntryId: string;
  } | null | undefined;
};
export type RemoveMealLoggingEntryMutation = {
  response: RemoveMealLoggingEntryMutation$data;
  variables: RemoveMealLoggingEntryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveMealLoggingEntryPayload",
    "kind": "LinkedField",
    "name": "removeMealLoggingEntry",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "removeMealLoggingEntryId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveMealLoggingEntryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveMealLoggingEntryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5be4bdd82de5539654762358383fd8ee",
    "id": null,
    "metadata": {},
    "name": "RemoveMealLoggingEntryMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveMealLoggingEntryMutation(\n  $input: RemoveMealLoggingEntryInput!\n) {\n  removeMealLoggingEntry(input: $input) {\n    removeMealLoggingEntryId\n  }\n}\n"
  }
};
})();

(node as any).hash = "74b7839373db91e3b6644f74ea942596";

export default node;
